import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormControlName, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IAssessScreen } from '../../../../shared/models/assessScreen';
import { EYesNo } from '../../../../shared/models/types.enum';

@Component({
  selector: 'evaluation-additional-info',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './evaluation-additional-info.component.html',
  styleUrl: './evaluation-additional-info.component.css'
})
export class EvaluationAdditionalInfoComponent implements OnInit {

  yesNo = EYesNo;
  
  @Input() assessScreenData: any;
  @Output() onSaveSection2 = new EventEmitter<IAssessScreen>();

  additionForm: FormGroup = new FormGroup({});
  questionList = [
    {
      question: "Do we understand the student's motives and goals? *",
      formControlName: "student_goal_understanding",
    },
    {
      question: "Have there been any communications suggesting ideas or intent to attack? *",
      formControlName: "student_communications",
    },
    {
      question: "Has the student shown inappropriate/concerning interest in school attacks or attackers, weapons, or incidents of mass violence? *",
      formControlName: "mass_violence",
    },
    {
      question: "Does the student have the capacity (resources or ability) to carry out the act? *",
      formControlName: "means_for_attack",
    },
    {
      question: "Has the student displayed stressors such as setbacks, losses, and other challenges? *",
      formControlName: "stressful_events",
    },
    {
      question: "Has the student experienced feelings related to a diagnosable mental illness, such as depression? *",
      formControlName: "student_mental_illness",
    },
    {
      question: "Is the student experiencing hopelessness, desperation, or despair? *",
      formControlName: "hopelessness_desparation",
    },
    {
      question: "Does the student see violence as an acceptable or desirable way to solve problems? *",
      formControlName: "acceptable_violence",
    },
    {
      question: "Are other people concerned about the individual's potential for violence? *",
      formControlName: "potential_violence",
    },
    {
      question: "Is the student's thinking and behaviors organized enough to plan and execute an attack? *",
      formControlName: "organized_behaviors",
    },
    {
      question: "Corroborate the student's statement. Is the student's conversation and 'story' consistent with their actions? *",
      formControlName: "story_fabrication",
    },
    {
      question: "Does the student have a positive, trusting relationship with an adult at school? *",
      formControlName: "positive_relationship_adult",
    },
  ]
  constructor() {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['assessScreenData'] && this.assessScreenData) {
      this.initializeForm();
    }
  }  

  onChanges(): void {
  }

  private initializeForm(): void {
    // radio input for each question
    this.questionList.forEach(question => {
      const controlName = question.formControlName;
      const defaultControlValue = this.assessScreenData ? String(this.assessScreenData[controlName]) : this.yesNo.NeedMoreInfo;
      this.additionForm.addControl(controlName, new FormControl(defaultControlValue, Validators.required));
    });
    // additional text inputs
    this.additionForm.addControl('stressful_events_information', new FormControl(this.assessScreenData?.stressful_events_information || ''));
    this.additionForm.addControl('home_stressors_information', new FormControl(this.assessScreenData?.home_stressors_information || ''));
  }

  saveAddition(): void {
    if (this.additionForm.invalid) {
      return;
    } else {
      this.onSaveSection2.emit(this.additionForm.value);
    }
  }
}
